import React from 'react';
import { Grid } from '@material-ui/core';
import FlexView from 'react-flexview/lib';
import { ReactComponent as LiabilityShieldIcon } from '../../assets/shield_with_v_blue.svg';
import { ReactComponent as CalenderIcon } from '../../assets/calendar.svg';
import { ReactComponent as AutoRenewGreenIcon } from '../../assets/renew.svg';
import { ReactComponent as AutoRenewRedIcon } from '../../assets/renew_red.svg';
import dayjs from 'dayjs';

const PolicyDetailsGrid = ({ 
    small,
    isRenewal, 
    insurance, 
    isActiveInsurance,
    dateFormat, 
    openConfirmationDialog 
}) => {
    return (
        <Grid container spacing={2} className="margin-bottom-large">
            {!isRenewal && <Grid item xs={3}>
                <FlexView column hAlignContent="center">
                <FlexView marginBottom={12}>

                        <LiabilityShieldIcon className=" x-medium-icon" />
                        </FlexView>

                    <FlexView className={`${small ? 'text-tiny' : 'text-small'} bold margin-top-small`}>Liability</FlexView>
                    <span className="text-tiny margin-top-small">${insurance.liabilityLimit.toLocaleString()}</span>
                </FlexView>
            </Grid>}
            {!isRenewal && <Grid item xs={6}>
                <FlexView column hAlignContent="center">
                <FlexView marginBottom={12}>

                        <CalenderIcon className="x-medium-icon" />
                        </FlexView>

                    <FlexView className={`${small ? 'text-tiny' : 'text-small'} bold margin-top-small`}>Coverage Period</FlexView>
                    <span className="text-tiny margin-top-small">{dayjs(insurance.insuranceStart).format(dateFormat)} - {dayjs(insurance.insuranceEnd).format(dateFormat)}</span>
                </FlexView>
            </Grid>}
            <Grid item xs={!isRenewal? 3 : 12}>
                <FlexView className={isActiveInsurance? 'clickable' : 'disabled'} column hAlignContent="center" onClick={openConfirmationDialog}>
                    <FlexView marginBottom={12}>
                        {insurance.autoRenew ? <AutoRenewGreenIcon className="x-medium-icon" /> : <AutoRenewRedIcon className="x-medium-icon" />}
                    </FlexView>
                    <span className={`${small ? 'text-tiny' : 'text-small'} center underline bold margin-top-small`}>Auto Renew</span>
                    <span className="text-tiny center margin-top-small">{insurance.autoRenew && isActiveInsurance ? dayjs(insurance._insuranceEnd).format(dateFormat) : 'Currently Off'}</span>
                </FlexView>
            </Grid>
        </Grid>
    );
};

export default PolicyDetailsGrid; 